// 아이콘 — Microsoft Fluent System Icons(@fluentui/react-icons, Outlook·Teams 와 같은 아이콘 체계).
// 화면에서 쓰는 이름(IconHome …)은 그대로 두고 내부만 공식 아이콘으로 매핑한다. 크기는 px(=font-size).
import type { JSX } from 'react';
import {
  AddRegular, ArchiveRegular, ArrowDownloadRegular, ArrowEnterRegular, ArrowExitRegular, ArrowShuffleRegular, BeachRegular,
  BriefcaseRegular, BuildingRegular, CalendarLtrRegular, CheckmarkCircleRegular, ClipboardTaskListLtrRegular,
  DataBarVerticalRegular, DataPieRegular, DocumentFolderRegular, HomeRegular, PeopleTeamRegular, ReceiptMoneyRegular, SettingsRegular,
  ShapesRegular, TextBulletListSquareRegular, WeatherMoonRegular, type FluentIcon,
} from '@fluentui/react-icons';

interface P { size?: number }
const make = (Icon: FluentIcon, base: number) => ({ size = base }: P): JSX.Element => (
  <Icon aria-hidden style={{ fontSize: size, flexShrink: 0 }} />
);

export const IconHome = make(HomeRegular, 20);
export const IconBoard = make(PeopleTeamRegular, 20);
export const IconLeave = make(BeachRegular, 20);
export const IconTrip = make(BriefcaseRegular, 20);
export const IconAdmin = make(ClipboardTaskListLtrRegular, 20); // 근무현황
export const IconApprove = make(CheckmarkCircleRegular, 20);
export const IconStats = make(DataBarVerticalRegular, 20);
export const IconPeopleStats = make(DataPieRegular, 20); // 임직원통계분석
export const IconSettings = make(SettingsRegular, 20);
export const IconIn = make(ArrowEnterRegular, 16);
export const IconOut = make(ArrowExitRegular, 16);
export const IconCalSmall = make(CalendarLtrRegular, 14);
export const IconPlus = make(AddRegular, 16);
export const IconDownload = make(ArrowDownloadRegular, 16);
export const IconCompany = make(BuildingRegular, 20);
export const IconCI = make(ShapesRegular, 20);
export const IconResources = make(DocumentFolderRegular, 20); // 문서함
export const IconWeekly = make(TextBulletListSquareRegular, 20);
export const IconExpense = make(ReceiptMoneyRegular, 20);
export const IconLibrary = make(ArchiveRegular, 20); // 자료실
export const IconPicker = make(ArrowShuffleRegular, 20);
export const IconOvertime = make(WeatherMoonRegular, 20); // 야근

/** Microsoft 로고(로그인 버튼) — 브랜드 마크라 아이콘 세트가 아닌 원래 4색 그대로 */
export const MsLogo = (): JSX.Element => (
  <span style={{ display: 'inline-grid', gridTemplateColumns: '1fr 1fr', gap: 2, width: 18, height: 18 }}>
    <span style={{ background: '#F25022' }} /><span style={{ background: '#7FBA00' }} />
    <span style={{ background: '#00A4EF' }} /><span style={{ background: '#FFB900' }} />
  </span>
);
